import { IPaginationParams } from 'services/types';
import { toUserMessage } from 'utils/apiErrorHelper';
import { api } from '../DefaultService';
import {
  IClassAttendanceDashboard,
  IClassDashboard,
  IClassNotificationStats,
  ICriticalStudent,
  IGlobalDashboard,
  ISchoolClassCreateParams,
  ISchoolClassFilterParams,
  ISchoolClassProps,
  ISchoolClassSidebarProps,
  ISchoolClassUpdateParams
} from './types';

const ENDPOINT = 'v1/schoolclass';

const fetchData = async <T>(promise: Promise<import('axios').AxiosResponse<T>>): Promise<T> => {
  try {
    const response = await promise;
    return response.data;
  } catch (error: any) {
    throw new Error(toUserMessage(error));
  }
};

export const createSchoolClassAsync = ({ data }: ISchoolClassCreateParams): Promise<ISchoolClassProps> => {
  return fetchData(api.post(ENDPOINT, data));
};

export const getSchoolClassByIdAsync = (id: number): Promise<ISchoolClassProps> => {
  return fetchData(api.get(`${ENDPOINT}/${id}`));
};

export const getAllSchoolClassByLicenseAsync = (
  pagination?: IPaginationParams,
  filter?: ISchoolClassFilterParams,
): Promise<ISchoolClassSidebarProps[]> => {
  return fetchData(api.get(`${ENDPOINT}/getAllByLicense`, { params: { ...pagination, ...filter } }));
};

export const updateSchoolClassAsync = ({ id, data }: ISchoolClassUpdateParams): Promise<ISchoolClassProps> => {
  return fetchData(api.put(`${ENDPOINT}/${id}`, data));
};

export const deleteSchoolClassAsync = (id: number): Promise<void> => {
  return fetchData(api.delete(`${ENDPOINT}/${id}`));
};

export const getAllSchoolClassCountAsync = (filter?: ISchoolClassFilterParams): Promise<number> => {
  return fetchData(api.get(`${ENDPOINT}/getAllByLicense/count`, { params: { ...filter } }));
};

export const getLiveAttendanceAsync = (id: number): Promise<IClassAttendanceDashboard> => {
  return fetchData(api.get(`${ENDPOINT}/${id}/live-attendance`));
};

export const getLiveAttendanceStreamEndpoint = (id: number): string => {
  return `${ENDPOINT}/${id}/live-attendance`; 
};

export const getClassNotificationStatsAsync = (id: number): Promise<IClassNotificationStats> => {
  return fetchData(api.get(`${ENDPOINT}/${id}/notification-stats`));
};

export const getCriticalStudentsAsync = (id: number): Promise<ICriticalStudent[]> => {
  return fetchData(api.get(`${ENDPOINT}/${id}/critical-students`));
};

export const getClassDashboardAsync = (id: number): Promise<IClassDashboard> => {
  return fetchData(api.get(`${ENDPOINT}/${id}/dashboard`));
};

export const getGlobalDashboardAsync = (): Promise<IGlobalDashboard> => {
  return fetchData(api.get(`${ENDPOINT}/global-dashboard`));
};